export const ALGOLIA_APP_ID = "9SIAEO72CT";
export const ALGOLIA_SEARCH_KEY = "55d28da04e4965cab632fadbf8bfa878";

export const colorModes = ["light", "dark", "grey"];
